module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/145.f8a30f4d.png";